import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { InView } from 'react-intersection-observer';

import { useSectionNavigation } from '../../context/SectionNavigationContext';

import styles from './LandingSection.module.scss';

const LandingSection = ({
  className = '',
  children,
  containerClassName = '',
  observableSection = null
}) => {
  const { handleInView, height: offset } = useSectionNavigation();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const wrapperRef = useRef(null);

  const handleOnScroll = () => {
    if (wrapperRef.current) {
      const { top, bottom } = wrapperRef.current.getBoundingClientRect();
      const offsetPlusOne = offset + 1;

      if (
        Math.round(top) <= offsetPlusOne &&
        Math.round(bottom) >= offsetPlusOne
      ) {
        handleInView(observableSection);
      }
    }
  };

  const handleInViewChange = inView => {
    if (inView && !isSubscribed) {
      document.addEventListener('scroll', handleOnScroll, true);
      setIsSubscribed(true);
    } else if (!inView) {
      document.removeEventListener('scroll', handleOnScroll, true);
      setIsSubscribed(false);
    }
  };

  return (
    <section
      className={classNames(styles['landing-section'], className)}
      data-sticky-in-navigation={observableSection}
      ref={wrapperRef}
    >
      {observableSection ? (
        <InView
          onChange={handleInViewChange}
          as="div"
          className={classNames(
            styles['landing-section__container'],
            containerClassName
          )}
        >
          {children}
        </InView>
      ) : (
        <div
          className={classNames(
            styles['landing-section__container'],
            containerClassName
          )}
        >
          {children}
        </div>
      )}
    </section>
  );
};

LandingSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  containerClassName: PropTypes.string,
  observableSection: PropTypes.string
};

export default LandingSection;
